import {Form} from 'antd'
import {InputText, Select} from '@/components/Form/index.mjs'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemUiName, FormItemUiUserCode} from '../UI/FormChooseUi.jsx'

const FormItemAlgCode = props => (
    <Form.Item
        label="能力代码"
        name="algUserCode"
        {...props}
    >
        <InputText allowClear />
    </Form.Item>
)

const FormItemAlgTitle = props => (
    <Form.Item
        label="能力名称"
        name="algTitle"
        {...props}
    >
        <InputText allowClear />
    </Form.Item>
)

const FormItemAlgType = (props) => (
    <Form.Item
        label="能力类型"
        name="algType"
        {...props}
    >
        <Select
            allowClear
            getOptionKey={e => e[0]}
            getOptionLabel={e => e[1]}
            options={[['基础', 'GENERAL'], ['事件', 'UE']]}
        />
    </Form.Item>
)

export default function FormChooseUe(props) {
    return (
        <FormChooseDesign {...props}>
                <FormItemUiUserCode />
                <FormItemUiName />
                <FormItemAlgTitle />
                <FormItemAlgCode />
                <FormItemAlgType />
        </FormChooseDesign>
    )
}
